import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  lubesRecentCardHanldeLikeState();
}

function lubesRecentCardHanldeLikeState() {
  // Use event delegation to handle dynamically added elements
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-au-lubes-recent-card-like]');
    if (!btn) return;

    const spanInButton = btn.querySelector('[data-au-icon]');
    const buttonHiddenLabel = btn.querySelector('[data-au-hidden-label]');
    const likeText = btn.dataset.auLubesRecentCardLike;
    const likedText = btn.dataset.auLubesRecentCardLiked;

    // Toggle the filled class for the like icon
    spanInButton.classList.toggle('au-lubes-recent-card__like-icon--filled');

    // Update the hidden label text based on the icon state
    if (spanInButton.classList.contains('au-lubes-recent-card__like-icon--filled')) {
      buttonHiddenLabel.textContent = likedText;
    } else {
      buttonHiddenLabel.textContent = likeText;
    }

    const titleText = btn
      .closest('[data-au-lubes-recent-card]')
      .querySelector('[data-au-lubes-recent-card-title]').innerText;

    const item_id = `favorito_${removeAccentMarkAndUppercase(titleText)}`;

    // datalayer
    window.dataLayer.push({
      event: 'navigation',
      content_type: 'clickIcono',
      item_id,
    });
  });
}

export default { init };
